import React from "react";

import CookieConsent from "react-cookie-consent";
import LogoAsset from "./../../../assets/logo_stroke.svg";

const ParentCookieConsent = () => {
  const cookie_overlayStyle = {
    color: "var(--color-neutral-white)",
    backgroundColor: "var(--color-neutral-black-opaque)",
    fontSize: "1rem",
  };

  const cookie_containerStyle = {
    display: "flex",
    FlexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "inherit",
    backgroundColor: "var(--color-background-primary)",
    padding: "24px",
    boxShadow: "var(--ui-shadow-regular)",
  };

  const cookie_contentStyle = {
    width: "100%",
    padding: "0 24px",
    margin: "24px 0",
    flex: "none",
  };

  const cookie_buttonStyle = {
    width: "100%",
    height: "48px",
    color: "var(--color-neutral-white)",
    backgroundColor: "var(--color-foreground-primary)",
    background: "var(--color-gradient-primary)",
    fontWeight: "bold",
    borderRadius: "24px",
    padding: "0 24px",
    margin: "8px auto 24px auto",
    boxShadow: "var(--ui-shadow-regular)",
    flex: "none",
  };

  return (
    <CookieConsent
      location="bottom"
      cookieName="cookieConsent"
      expires={365}
      overlay={true}
      overlayStyle={cookie_overlayStyle}
      // @ts-ignore --> linting error, interprets code correctly
      style={cookie_containerStyle}
      contentStyle={cookie_contentStyle}
      buttonStyle={cookie_buttonStyle}
      buttonClasses={"cookie-button"}
      buttonText="Ich stimme zu."
    >
      <img
        src={LogoAsset}
        alt="Logo"
        width={"auto"}
        height={"48px"}
        style={{
          width: "100%",
          textAlign: "center",
          marginBottom: "24px",
        }}
      />
      <p>
        Diese Webseite verwendet funktionale Cookies, um das Benutzererlebnis zu
        steigern.
      </p>
    </CookieConsent>
  );
};

export default ParentCookieConsent;
